import { Button, Card, Flex, Image, Input, Space, Table } from 'antd';
import { EditOutlined, EyeOutlined, PlusCircleOutlined } from '@ant-design/icons';
import ProductCollectionModal from 'components/product_collection';

const { Search } = Input;

const ProductCollectionDesktop = ({ viewModel }) => {
  const {
    data,
    loading,
    openModal,
    selectedId,
    loadData,
    onSearch,
    openCreateModal,
    openEditModal,
    closeModal,
    getViewLink,
    renderCollectionType,
  } = viewModel;

  const columns = [
    {
      title: 'Hình ảnh',
      render: (_, record) => {
        const image = record.avatar || record.image;
        return image ? <Image src={image.url} width={50} /> : null;
      },
    },
    {
      title: 'Tên',
      dataIndex: 'title',
    },
    {
      title: 'Mô tả',
      dataIndex: 'description',
    },
    {
      title: 'Cách chọn sản phẩm',
      render: (_, record) => renderCollectionType(record.collection_condition),
    },
    {
      title: 'Hành động',
      render: (_, record) => (
        <Space>
          <Button icon={<EyeOutlined />} onClick={() => window.open(getViewLink(record), '_blank')} />
          <Button icon={<EditOutlined />} onClick={() => openEditModal(record.id)} />
        </Space>
      ),
    },
  ];

  return (
    <Space direction='vertical' style={{ width: '100%' }}>
      <Card>
        <Flex style={{ marginBottom: 16, gap: 16 }}>
          <Search placeholder='Tìm kiếm' onSearch={onSearch} />
        </Flex>

        <Flex justify='end'>
          <Button type='primary' onClick={openCreateModal}>
            <PlusCircleOutlined /> Tạo mới
          </Button>
        </Flex>
      </Card>

      <Card>
        <Table columns={columns} dataSource={data} loading={loading} rowKey='id' />
      </Card>

      <ProductCollectionModal open={openModal} id={selectedId} onClose={closeModal} onChange={loadData} />
    </Space>
  );
};

export default ProductCollectionDesktop;
